// GET_USER
export const GET_ORDER = "GET_ORDER";

// GET_ORDER_DETAIL
export const GET_ORDER_DETAIL = "GET_ORDER_DETAIL";

// UPDATE_ORDER

export const UPDATE_ORDER = "UPDATE_ORDER";


export const ORDER_LOADING = "ORDER_LOADING";
